import IconSearch from "../SvgIcon/IconSearch";

export default function SearchBar({ searchQuery, setSearchQuery, onClear }) {
  return (
    <div className="d-flex gap-2 searchbar position-relative">
      <input
        type="text"
        name="text"
        placeholder="Search Here.."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      <div className="position-absolute">
        <IconSearch />
      </div>
      {searchQuery && (
        <button
          className="position-absolute clear-button"
          type="button"
          onClick={onClear}
          data-bs-toggle="tooltip"
          data-bs-placement="left"
          title="Clear Filters"
        >
          ✖
        </button>
      )}
    </div>
  );
}
